import React, { useEffect, useState } from 'react'
import { UserMenu, MenuItemLink, Logout, useDataProvider, useUserMenu } from 'react-admin'
import SettingsIcon from '@mui/icons-material/Settings'
import Avatar from '@mui/material/Avatar'
import { Box, Typography } from '@mui/material'

import { useProfile } from '../pages/profile'

const MyCustomIcon = ({ avatar, name }) => (
  <Box display="flex" alignItems="center">
    <Avatar
      sx={{
        height: 30,
        width: 30,
        mr: 1,
      }}
      src={avatar}
      alt={name}
    />
    <Typography variant="h6" color="inherit" fontWeight={'semibold'}>
      {name}
    </Typography>
  </Box>
)

const ConfigurationMenu = () => {
  const { onClose } = useUserMenu()
  return (
    <MenuItemLink
      to="/my-profile"
      primaryText="My Profile"
      leftIcon={<SettingsIcon />}
      onClick={onClose}
    />
  )
}

const MyUserMenu = (props) => {
  const { profileVersion } = useProfile()
  const dataProvider = useDataProvider()
  const [userProfile, setUserProfile] = useState({ avatar: '', name: '' })

  useEffect(() => {
    dataProvider.getUserProfile().then((response) => {
      const { data } = response
      setUserProfile({
        avatar: data.avatar || '',
        name: data.fullName || 'Admin',
      })
    })
  }, [profileVersion, dataProvider])

  return (
    <UserMenu
      key={profileVersion}
      icon={<MyCustomIcon avatar={userProfile.avatar} name={userProfile.name} />}
      {...props}
    >
      <ConfigurationMenu />
      <Logout />
    </UserMenu>
  )
}

export default MyUserMenu
